import React, {  useState } from "react";
import './Header.css'
import { useCenter } from "../context/CenterContext";
import CentreSwitcherModal from "./CentreSwitcherModal";

const Header = () => {
  const [showModal, setShowModal] = useState(false);
  const {   centerName, centerNumber } 
  = useCenter();
  return (
    <>
      <CentreSwitcherModal isOpen={showModal} onClose={() => setShowModal(false)} />

      <div className="global-header">
        <div
          className="change-centre js-modal-trigger"
          id="pnlCentreSwitcher"
          onClick={() => setShowModal(true)}
          data-target="modal-centre-switcher"
        >
          <a role="button">
            <svg
              className="icon"
              focusable="false"
              aria-hidden="true"
              viewBox="0 0 24 24"
              data-testid="DomainIcon"
            >
              <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"></path>
            </svg>
            {centerNumber && (
              <span className="change-centre-detail">
                <span className="centre-number">{centerNumber || ''}</span>
                <span
                  className="centre-name"
                  title={centerName || ''}
                >
                  { centerName || ''}
                </span>
              </span>
            )}

            <svg
              id="svgChangeCentreTrigger"
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#FFFFFF"
            >
              <path d="M480-120 300-300l58-58 122 122 122-122 58 58-180 180ZM358-598l-58-58 180-180 180 180-58 58-122-122-122 122Z"></path>
            </svg>
          </a>
        </div>
      </div>
    </>
  );
};

export default Header;
